/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Shoutcast.Account.Api
 * OpenAPI spec version: 1.0
 */

import { accountApiFetcher } from "../fetchers";
import type {
	AccountDto,
	AccountUpdateRequest,
	AuthenticationResponse,
	LoginCommand,
	LostPasswordRequest,
	NoContentResult,
	RecoverPasswordRequest,
	RecoverPasswordWithTokenRequest,
	RefreshTokenRequest,
	UpdatePasswordRequest,
} from "./api.schemas";

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
	T,
>() => T extends Y ? 1 : 2
	? A
	: B;

type WritableKeys<T> = {
	[P in keyof T]-?: IfEquals<
		{ [Q in P]: T[P] },
		{ -readonly [Q in P]: T[P] },
		P
	>;
}[keyof T];

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (
	k: infer I,
) => void
	? I
	: never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
	? {
			[P in keyof Writable<T>]: T[P] extends object
				? NonReadonly<NonNullable<T[P]>>
				: T[P];
		}
	: DistributeReadOnlyOverUnions<T>;

export type putApiAccountResponse200 = {
	data: AccountDto;
	status: 200;
};

export type putApiAccountResponseComposite = putApiAccountResponse200;

export type putApiAccountResponse = putApiAccountResponseComposite & {
	headers: Headers;
};

export const getPutApiAccountUrl = () => {
	return `/api/Account`;
};

export const putApiAccount = async (
	accountUpdateRequest: AccountUpdateRequest,
	options?: RequestInit,
): Promise<putApiAccountResponse> => {
	return accountApiFetcher<putApiAccountResponse>(getPutApiAccountUrl(), {
		...options,
		method: "PUT",
		headers: { "Content-Type": "application/json", ...options?.headers },
		body: JSON.stringify(accountUpdateRequest),
	});
};

export type getApiAccountResponse200 = {
	data: AccountDto;
	status: 200;
};

export type getApiAccountResponseComposite = getApiAccountResponse200;

export type getApiAccountResponse = getApiAccountResponseComposite & {
	headers: Headers;
};

export const getGetApiAccountUrl = () => {
	return `/api/Account`;
};

export const getApiAccount = async (
	options?: RequestInit,
): Promise<getApiAccountResponse> => {
	return accountApiFetcher<getApiAccountResponse>(getGetApiAccountUrl(), {
		...options,
		method: "GET",
	});
};

export type postApiAccountChangePasswordResponse204 = {
	data: NoContentResult;
	status: 204;
};

export type postApiAccountChangePasswordResponseComposite =
	postApiAccountChangePasswordResponse204;

export type postApiAccountChangePasswordResponse =
	postApiAccountChangePasswordResponseComposite & {
		headers: Headers;
	};

export const getPostApiAccountChangePasswordUrl = () => {
	return `/api/Account/change-password`;
};

export const postApiAccountChangePassword = async (
	updatePasswordRequest: UpdatePasswordRequest,
	options?: RequestInit,
): Promise<postApiAccountChangePasswordResponse> => {
	return accountApiFetcher<postApiAccountChangePasswordResponse>(
		getPostApiAccountChangePasswordUrl(),
		{
			...options,
			method: "POST",
			headers: { "Content-Type": "application/json", ...options?.headers },
			body: JSON.stringify(updatePasswordRequest),
		},
	);
};

export type postApiAuthRefreshResponse200 = {
	data: null;
	status: 200;
};

export type postApiAuthRefreshResponseComposite = postApiAuthRefreshResponse200;

export type postApiAuthRefreshResponse = postApiAuthRefreshResponseComposite & {
	headers: Headers;
};

export const getPostApiAuthRefreshUrl = () => {
	return `/api/auth/refresh`;
};

export const postApiAuthRefresh = async (
	refreshTokenRequest: NonReadonly<RefreshTokenRequest>,
	options?: RequestInit,
): Promise<postApiAuthRefreshResponse> => {
	return accountApiFetcher<postApiAuthRefreshResponse>(
		getPostApiAuthRefreshUrl(),
		{
			...options,
			method: "POST",
			headers: { "Content-Type": "application/json", ...options?.headers },
			body: JSON.stringify(refreshTokenRequest),
		},
	);
};

export type postApiAuthLoginResponse200 = {
	data: AuthenticationResponse;
	status: 200;
};

export type postApiAuthLoginResponseComposite = postApiAuthLoginResponse200;

export type postApiAuthLoginResponse = postApiAuthLoginResponseComposite & {
	headers: Headers;
};

export const getPostApiAuthLoginUrl = () => {
	return `/api/auth/login`;
};

export const postApiAuthLogin = async (
	loginCommand: LoginCommand,
	options?: RequestInit,
): Promise<postApiAuthLoginResponse> => {
	return accountApiFetcher<postApiAuthLoginResponse>(getPostApiAuthLoginUrl(), {
		...options,
		method: "POST",
		headers: { "Content-Type": "application/json", ...options?.headers },
		body: JSON.stringify(loginCommand),
	});
};

export type postApiAuthLostPasswordResponse204 = {
	data: NoContentResult;
	status: 204;
};

export type postApiAuthLostPasswordResponseComposite =
	postApiAuthLostPasswordResponse204;

export type postApiAuthLostPasswordResponse =
	postApiAuthLostPasswordResponseComposite & {
		headers: Headers;
	};

export const getPostApiAuthLostPasswordUrl = () => {
	return `/api/auth/lost-password`;
};

export const postApiAuthLostPassword = async (
	lostPasswordRequest: LostPasswordRequest,
	options?: RequestInit,
): Promise<postApiAuthLostPasswordResponse> => {
	return accountApiFetcher<postApiAuthLostPasswordResponse>(
		getPostApiAuthLostPasswordUrl(),
		{
			...options,
			method: "POST",
			headers: { "Content-Type": "application/json", ...options?.headers },
			body: JSON.stringify(lostPasswordRequest),
		},
	);
};

export type postApiAuthRecoverPasswordWithTokenResponse204 = {
	data: NoContentResult;
	status: 204;
};

export type postApiAuthRecoverPasswordWithTokenResponseComposite =
	postApiAuthRecoverPasswordWithTokenResponse204;

export type postApiAuthRecoverPasswordWithTokenResponse =
	postApiAuthRecoverPasswordWithTokenResponseComposite & {
		headers: Headers;
	};

export const getPostApiAuthRecoverPasswordWithTokenUrl = () => {
	return `/api/auth/recover-password-with-token`;
};

export const postApiAuthRecoverPasswordWithToken = async (
	recoverPasswordWithTokenRequest: RecoverPasswordWithTokenRequest,
	options?: RequestInit,
): Promise<postApiAuthRecoverPasswordWithTokenResponse> => {
	return accountApiFetcher<postApiAuthRecoverPasswordWithTokenResponse>(
		getPostApiAuthRecoverPasswordWithTokenUrl(),
		{
			...options,
			method: "POST",
			headers: { "Content-Type": "application/json", ...options?.headers },
			body: JSON.stringify(recoverPasswordWithTokenRequest),
		},
	);
};

export type postApiAuthRecoverPasswordResponse204 = {
	data: NoContentResult;
	status: 204;
};

export type postApiAuthRecoverPasswordResponseComposite =
	postApiAuthRecoverPasswordResponse204;

export type postApiAuthRecoverPasswordResponse =
	postApiAuthRecoverPasswordResponseComposite & {
		headers: Headers;
	};

export const getPostApiAuthRecoverPasswordUrl = () => {
	return `/api/auth/recover-password`;
};

export const postApiAuthRecoverPassword = async (
	recoverPasswordRequest: RecoverPasswordRequest,
	options?: RequestInit,
): Promise<postApiAuthRecoverPasswordResponse> => {
	return accountApiFetcher<postApiAuthRecoverPasswordResponse>(
		getPostApiAuthRecoverPasswordUrl(),
		{
			...options,
			method: "POST",
			headers: { "Content-Type": "application/json", ...options?.headers },
			body: JSON.stringify(recoverPasswordRequest),
		},
	);
};

export type getFilesIdExtensionResponse200 = {
	data: null;
	status: 200;
};

export type getFilesIdExtensionResponseComposite =
	getFilesIdExtensionResponse200;

export type getFilesIdExtensionResponse =
	getFilesIdExtensionResponseComposite & {
		headers: Headers;
	};

export const getGetFilesIdExtensionUrl = (
	id: string | undefined | null,
	extension: string | undefined | null,
) => {
	return `/Files/${id}/${extension}`;
};

export const getFilesIdExtension = async (
	id: string | undefined | null,
	extension: string | undefined | null,
	options?: RequestInit,
): Promise<getFilesIdExtensionResponse> => {
	return accountApiFetcher<getFilesIdExtensionResponse>(
		getGetFilesIdExtensionUrl(id, extension),
		{
			...options,
			method: "GET",
		},
	);
};

export type getFilesTemplatePaymentResponse200 = {
	data: null;
	status: 200;
};

export type getFilesTemplatePaymentResponseComposite =
	getFilesTemplatePaymentResponse200;

export type getFilesTemplatePaymentResponse =
	getFilesTemplatePaymentResponseComposite & {
		headers: Headers;
	};

export const getGetFilesTemplatePaymentUrl = () => {
	return `/Files/template-payment`;
};

export const getFilesTemplatePayment = async (
	options?: RequestInit,
): Promise<getFilesTemplatePaymentResponse> => {
	return accountApiFetcher<getFilesTemplatePaymentResponse>(
		getGetFilesTemplatePaymentUrl(),
		{
			...options,
			method: "GET",
		},
	);
};

export type getFilesTemplateRevenueResponse200 = {
	data: null;
	status: 200;
};

export type getFilesTemplateRevenueResponseComposite =
	getFilesTemplateRevenueResponse200;

export type getFilesTemplateRevenueResponse =
	getFilesTemplateRevenueResponseComposite & {
		headers: Headers;
	};

export const getGetFilesTemplateRevenueUrl = () => {
	return `/Files/template-revenue`;
};

export const getFilesTemplateRevenue = async (
	options?: RequestInit,
): Promise<getFilesTemplateRevenueResponse> => {
	return accountApiFetcher<getFilesTemplateRevenueResponse>(
		getGetFilesTemplateRevenueUrl(),
		{
			...options,
			method: "GET",
		},
	);
};
